import React from 'react';

import SelectItemModal from 'template/Modals/SelectItem';
import getStudentSummary from 'controllers/student/getStudentSummary'
import updateMultiLesson from 'controllers/lesson/updateMultiLesson'
import {fetchClassLesson} from 'containers/pages/ClassDetail/ducks'
import Student from 'mediators/Student';
//
// User can select a student.
// a wraper of SelectItemModal
//
// eg.
// SelectStudent({ schoolId })
//  .then()
//  .catch()
//
export default function(opts) {
  const {
    schoolId,
    selectMultiple,
    classID,
    lesson_id_list,
    dispatch,
    pagination,
    state,
    itemPerPage = 25
  } = opts;

  let conflicted = {};
  // this will return a promise
  return SelectItemModal({
    headerTitle: __('Reset Lesson Student', 'lessonTable'),
    headerIcon: 'fa icon-book-reader',
    itemName: __('Student', 'schedule'),
    searchPlaceholder: __('Search Student', 'schedule'),
    selectMultiple: selectMultiple,
    showName: true,
    backendSearch: true,
    getItemLabel: (student)=>{
      return student.sName;
    },
    fetchItems: (cb, opts)=>{
      const {
        searchKeyword,
        currentPageNumber,
      } = opts;

      getStudentSummary({
        schoolId,
        itemPerPage,
        searchKeyword,
        pageNumber: currentPageNumber,
        studentState: 'all_not_archived',
      })
        .then((data)=>{ 
          const pageMeta = {
            maxPageNumber: data.pageAmount,
          };
          if (currentPageNumber > data.pageAmount) {
            return cb([], pageMeta);
          }
          const {list} = data;
          cb(list, pageMeta);
        })
        .catch((err)=>{ console.error(err); });
    },
    onConfirm: (props, Modal) => {
      let studentArr = []
      props.selected.map((s) => { studentArr.push(s.schoolStudentID)})
      updateMultiLesson(classID, {lesson_id_list, student_id_list: studentArr, conflict_tag: 'allLessonNotAdd'})
      .then((res) => {
        if(res.result == 'edit failed because of conflict'){
          res.conflicted_detail.map((conflict) => {
            conflict.conflicted_detail.student.conflicted_student_list.map((student) => {
              conflicted[student.student_id] = true
            })
          })
          Modal.forceUpdate();
        } else {
          dispatch(fetchClassLesson(classID, {
            amount_per_page: pagination.itemsCountPerPage,
            current_page_number: pagination.activePage,
            after_today: state
          }))
          props.proceed()
        }
      })
    },
    components: {
      SelectItem: ({item, getItemLabel, selected, onClickSelect, selectText, selectedText, mixin}, Modal) => {

        return (
          <div className='select-item' >
            <div>
              { item.sName }
            </div>
            <div className='select-button'>
              { conflicted[item.schoolStudentID] && <span style={{ color: 'red' }}>{__('Conflict', 'classdetail')}</span> }
              { selected && <span className='btn-link currently-selected' onClick={onClickSelect}>{selectText || __('Selected', 'SelectItemModal')}</span>}
              { !selected && <span className='btn-link' onClick={onClickSelect}>{selectedText || __('Select', 'SelectItemModal')}</span>}
            </div>
          </div>
         );
      }
    },

    ...opts,

  })
}



// WEBPACK FOOTER //
// ./src/template/Modals/LessonEditStudent/index.js